import {Text} from 'react-native'

export default props => <Text {...props} style={[{fontFamily: 'Nunito'}, props.style]}>{props.children}</Text>